// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n0-0";
export var animationContainer = "_n0-1";
export var itemPrice = "_n0-a";
export var itemizedContent = "_n0-9";
export var itemizedHeader = "_n0-7";
export var itemizedRow = "_n0-8";
export var itemizedSection = "_n0-6";
export var modalContent = "_n0-2";
export var orderName = "_n0-3";
export var refundOption = "_n0-4";
export var refundOptionsContainer = "_n0-5";
export var shippingLabel = "_n0-b";
export var totalRow = "_n0-c";